module.exports = __webpack_public_path__ + "static/media/1_A1_04.fc0c593c.png";